import {HttpClient} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {EMPTY, Observable, of, Subject} from 'rxjs';
import {filter, switchMap, takeUntil} from 'rxjs/operators';
import {DISPATCHER_PREFIX} from '../../../../../../../mx-core/src/lib/consts/data-service-consts';
import {AcceptPortalNotificationPrlObj, PortalNotificationPrlObj} from '../../../../models/portal-notification.model';
import {PrlInitializer} from '../../../../shared/services/prl-initializer.interface';
import {PrlAuthenticationService} from '../../../../shared/services/prl-authentication.service';

const PORTAL_NOTIFICATIONS_REST: string = DISPATCHER_PREFIX + '/portal-notifications';

export const PORTAL_NOTIFICATION_PAGE_URL: string = '/portal-notifications';

@Injectable({
    providedIn: 'root'
})
export class PrlPortalNotificationService implements PrlInitializer {

    private _destroy$$: Subject<null> = new Subject<null>();
    private authService: PrlAuthenticationService;

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private injector: Injector
    ) {
    }

    init(): Observable<void> {
        this.authService = this.injector.get(PrlAuthenticationService);

        this.router.events
            .pipe(
                takeUntil(this._destroy$$),
                filter(event => event instanceof NavigationEnd),
                switchMap(() => this.loadNotification()))
            .subscribe(notification => {
                if (notification) {
                    this.router.navigate([PORTAL_NOTIFICATION_PAGE_URL]);
                }
            });

        return of(void 0);
    }


    public getPortalNotification(): Observable<PortalNotificationPrlObj> {
        return this.httpClient.get<PortalNotificationPrlObj>(PORTAL_NOTIFICATIONS_REST);
    }

    public acceptPortalNotification(id: number, accepted: boolean): Observable<void> {
        const obj: AcceptPortalNotificationPrlObj = {id, accepted};
        return this.httpClient.post<void>(PORTAL_NOTIFICATIONS_REST, obj);
    }

    private loadNotification(): Observable<PortalNotificationPrlObj> {
        if (!this.authService.token || this.router.url === PORTAL_NOTIFICATION_PAGE_URL
            || !JSON.parse(localStorage.getItem('isTcAccepted'))) {
            return EMPTY;
        }
        return this.getPortalNotification();
    }

    destroy(): void {
        this._destroy$$.next(null);
    }
}
